import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'sls_ops_log_role',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isSls());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/SlsPerimeter.js